class ShopTheLookDrawer extends HTMLDivElement {
  constructor() {
    super();

    this.elements = {
      list: this.querySelector('[data-shop-the-look-drawer-el="list"]')
    }
  }

  connectedCallback() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    window.addEventListener('shop-the-look-drawer:update', this.handleUpdate.bind(this));
  }

  handleUpdate(event) {
    this.products = event.detail.products;

    this.elements.list.innerHTML = '';

    this.products.forEach(product => {
      this.sectionRenderCard(product)
    })
  }

  sectionRenderCard(product) {
    fetch(`/products/${product.handle}?section_id=product-card`)
      .then(response => response.text())
      .then(data => {
        const innerHTML = new DOMParser().parseFromString(data, 'text/html');

        const productCard = innerHTML.querySelector('product-item');

        const listItem = document.createElement('li');
        listItem.appendChild(productCard);

        this.elements.list.insertAdjacentElement('beforeend', listItem);
      })
  }
}

customElements.define('shop-the-look-drawer', ShopTheLookDrawer, { extends: 'div' });
